import { graphql } from 'react-relay';

export const inforServicePageFragment = graphql`
    fragment InfoServicePage_page on InfoServicePage 
    @argumentDefinitions(
      salesAdmission: { type: "String", defaultValue: "AT" }
      retailOnly: { type: "Boolean", defaultValue: true }
    )
    {
      salesadmission {
        ...LabeledSelectBox_labeledSelectBox
      }
      retailOnly {
        ...LabeledSelectBox_labeledSelectBox
      }
      components(first: 1000)  {
        edges {
          node {
            __typename
            ...SubscriptionIntroduction_component
            ...AboManager_component @arguments(salesAdmission: $salesAdmission, retailOnly: $retailOnly)
          }
        }
      }
      breadcrumbs {
        ...Breadcrumb_data
      }
      path
      id
  }
`;
